import React from 'react';
import { Margin, P, Ul, Li } from '@ovotech/element-v4';
import { ModalStepTitle } from '@/src/pages/AnytimeEligibilityV2/pages/PreEligibilityProducts/PreEligibilityProducts.styled';

export const NeedToKnowStep1: React.FC = () => (
  <Margin top={6}>
    <ModalStepTitle>How pay monthly plans work</ModalStepTitle>
    <Margin bottom={6}>
      <P>
        <strong>Pay Monthly mileage allowance renews every month.</strong>
      </P>
      <Margin top={4} />
      <Ul>
        <Li>The miles reset at the start of each month</Li>
        <Li>The miles don't roll over to the next month</Li>
      </Ul>
    </Margin>
    <Margin bottom={2}>
      <P>
        If you go over your monthly allowance or Urgent Charge you’ll be charged
        at your usual home tariff rate.
      </P>
    </Margin>
  </Margin>
);
